import { useEffect, useMemo, useState } from "react"
import { Link, useLocation } from "react-router-dom"
// import { BOT_STATUS, PROFILES } from "../constants";
import useAccounts from "../hooks/useAccounts";
import { useSession } from "../hooks/useSession";
import { useTranslation } from "react-i18next";
import HasAccess from "../guards/HasAccess";
import { BotService } from "../services/BotService";
import { useCurrentAccount } from "../hooks/useCurrentAccount";
declare const HSSideNav: any;

function Aside({ mini = false }) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const { session } = useSession()
    const [chatbotInfo, setChatbotInfo] = useState(null);

    const location = useLocation()

    // const urlBotModule = useMemo(() => {
    //     if (roleSession === PROFILES.ROOT) {
    //         return '/bot/accounts';
    //     }

    //     // if (chatbotInfo?.status === BOT_STATUS.NOT_SHOW) {
    //     //     return '/bot/activation';
    //     // }

    //     return '/bot/builder';
    // }, [roleSession, chatbotInfo])

    const urlBotReport = useMemo(() => {
        // if (chatbotInfo?.status === BOT_STATUS.NOT_SHOW) {
        //     return '/bot/activation';
        // }

        return '/reports/chatbot';
    }, [chatbotInfo])

    const getChatbotInfo = async () => {
        const { data } = await BotService.getChatbotInfo(account.account_id);
        setChatbotInfo(data);
    }

    useEffect(() => {

        if (mini) {
            document.body.classList.add('navbar-vertical-aside-mini-mode');
        }

        return () => {
            if (mini) {
                document.body.classList.remove('navbar-vertical-aside-mini-mode');
            }
        }
    }, [mini])

    useEffect(() => {

        getChatbotInfo()

        const instance = new HSSideNav('.js-navbar-vertical-aside')
        instance.init()

        return () => {
            try { instance.init() } catch (error) { }
        }
    }, [])

    if (session && session.id === 5084) {
      return (
        <aside className="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered  navbar-voices">
          <div className="navbar-vertical-container">
            <div className="navbar-vertical-footer-offset">
              <a
                className="navbar-brand"
                href="../index.html"
                aria-label="Front"
              >
                <img
                  className="navbar-brand-logo"
                  src="/assets/img/logo.png"
                  alt="Logo"
                  data-hs-theme-appearance="default"
                />
                <img
                  className="navbar-brand-logo"
                  width={"160px"}
                  src="/assets/img/logo-dark.png"
                  alt="Logo"
                  data-hs-theme-appearance="dark"
                />
                <img
                  className="navbar-brand-logo-mini"
                  src="/assets/img/logo-circle-voices.png"
                  alt="Logo"
                  data-hs-theme-appearance="default"
                />
              </a>
              <button
                title="button-toggle"
                type="button"
                className="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler"
              >
                <i className="bi-arrow-bar-left navbar-toggler-short-align"></i>
                <i className="bi-arrow-bar-right navbar-toggler-full-align"></i>
              </button>

              <div className="navbar-vertical-content">
                <div
                  id="navbarVerticalMenu"
                  className="nav nav-pills nav-vertical card-navbar-nav"
                >
                  <span className="dropdown-header fw-bold text-white-dark">
                    {t("components.aside.operation-title")}
                  </span>
                  <small className="bi-three-dots nav-subtitle-replacer"></small>

                    <div className="nav-item ">
                        <Link
                        className="nav-link dropdown-toggle"
                        to="/"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarVerticalMenuReports"
                        >
                        <i className="bi-grid-1x2 nav-icon text-dark fw-bolder"></i>
                        <span className="nav-link-title">
                            {t("components.aside.reports.reports-title")}
                        </span>
                        </Link>
                        <div
                        id="navbarVerticalMenuReports"
                        className={
                            `nav-collapse collapse  ` +
                            (location.pathname.startsWith("/reports")
                            ? "show"
                            : "")
                        }
                        data-bs-parent="#navbarVerticalMenu"
                        hs-parent-area="#navbarVerticalMenu"
                        >
                        <Link
                            className={
                            `nav-link ` +
                            (location.pathname.startsWith("/reports/licencias")
                                ? "active"
                                : "")
                            }
                            to="/reports/licencias"
                        >
                            Licencias
                        </Link>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </aside>
      );
    }

    return (
        <aside className="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered  navbar-voices" >
            <div className="navbar-vertical-container">
                <div className="navbar-vertical-footer-offset">

                    <a className="navbar-brand" href="../index.html" aria-label="Front">
                        <img className="navbar-brand-logo" src="/assets/img/logo.png" alt="Logo" data-hs-theme-appearance="default" />
                        <img className="navbar-brand-logo" width={'160px'} src="/assets/img/logo-dark.png" alt="Logo" data-hs-theme-appearance="dark" />
                        <img className="navbar-brand-logo-mini" src="/assets/img/logo-circle-voices.png" alt="Logo" data-hs-theme-appearance="default" />
                    </a>
                    <button title="button-toggle" type="button" className="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
                        <i className="bi-arrow-bar-left navbar-toggler-short-align" ></i>
                        <i className="bi-arrow-bar-right navbar-toggler-full-align"  ></i>
                    </button>


                    <div className="navbar-vertical-content">
                        <div id="navbarVerticalMenu" className="nav nav-pills nav-vertical card-navbar-nav">

                            <span className="dropdown-header fw-bold text-white-dark">{t("components.aside.operation-title")}</span>
                            <small className="bi-three-dots nav-subtitle-replacer"></small>

                            <HasAccess permission={'dashboard.show'}>
                                <div className="nav-item">
                                    <Link className={`nav-link ${location.pathname === '/' || location.pathname.startsWith('/dashboard') ? 'active' : ''}`} to='/dashboard' >
                                        <i className="bi-speedometer2 nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.dashboard")}</span>
                                    </Link>
                                </div>
                            </HasAccess>

                            <HasAccess permission={'reports.show'}>
                                <div className="nav-item ">
                                    <Link className="nav-link dropdown-toggle" to='/' data-bs-toggle="collapse" data-bs-target="#navbarVerticalMenuReports" >
                                        <i className="bi-grid-1x2 nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.reports.reports-title")}</span>
                                    </Link>
                                    <div id="navbarVerticalMenuReports" className={`nav-collapse collapse  ` + (location.pathname.startsWith('/reports') ? 'show' : '')} data-bs-parent="#navbarVerticalMenu" hs-parent-area="#navbarVerticalMenu" >
                                        {/* <Link className={`nav-link ` + (location.pathname.startsWith('/reports/quiz') ? 'active' : '')} to='/reports/quiz'>{t("components.aside.reports.quiz")}</Link> */}
                                        <Link className={`nav-link ` + (location.pathname.startsWith('/reports/tickets') ? 'active' : '')} to='/reports/tickets'>{t("components.aside.reports.tickets")}</Link>
                                        <Link className={`nav-link ` + (location.pathname.startsWith('/reports/agents') ? 'active' : '')} to='/reports/agents'>{t("components.aside.reports.agents")}</Link>
                                        {/* <Link className={`nav-link ` + (location.pathname.startsWith('/reports/payments') ? 'active' : '')} to='/reports/payments'>{t("components.aside.reports.payments")}</Link> */}
                                        <Link className={`nav-link ` + (location.pathname.startsWith('/reports/customers') ? 'active' : '')} to='/reports/customers'>{t("components.aside.reports.customers")}</Link>
                                        {/* <Link className={`nav-link ` + (location.pathname.startsWith('/reports/chatbot') ? 'active' : '')} to={urlBotReport}>{t("components.aside.reports.chatbot")}</Link> */}
                                        {/* <Link className={`nav-link ` + (location.pathname.startsWith('/reports/billing') ? 'active' : '')} to='/reports/billing'>{t("components.aside.reports.billing")}</Link> */}
                                        {/* <Link className={`nav-link ` + (location.pathname.startsWith('/reports/conversion') ? 'active' : '')} to='/reports/conversion'>{t("reports.convertion.convertion-title")}</Link> */}
                                        {/* <Link className={`nav-link ` + (location.pathname.startsWith('/reports/api') ? 'active' : '')} to='/reports/api'>API</Link> */}
                                        <Link className={`nav-link ` + (location.pathname.startsWith('/reports/blacklist') ? 'active' : '')} to='/reports/blacklist'>Blacklist</Link>
                                        <Link className={`nav-link ` + (location.pathname.startsWith('/reports/blacklist-words') ? 'active' : '')} to='/reports/blacklist-words'>{t("config.blacklist.blacklist-title")}</Link>
                                    </div>
                                </div>
                            </HasAccess>
                            <HasAccess permission={'accounts_db.show'}>
                                <div className="nav-item ">
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/bd-clients') ? 'active' : '')} to='/bd-clients'>
                                        <i className="bi-person-bounding-box nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.customer-base")}</span>
                                    </Link>
                                </div>
                            </HasAccess>

                            {/* <div className="nav-item">
                                <Link className="nav-link dropdown-toggle" to='/' data-bs-toggle="collapse" data-bs-target="#navbarCampaigns">
                                    <i className="bi-send-plus nav-icon text-dark fw-bolder"></i>
                                    <span className="nav-link-title">{t('campaigns.monitoring.breadcrumb-campaigns')}</span>
                                </Link>
                                <div id="navbarCampaigns" className={`nav-collapse collapse ` + (location.pathname.startsWith('/campaigns') ? 'show' : '')} data-bs-parent="#navbarFollowUp" hs-parent-area="#navbarFollowUp" >
                                </div>
                            </div> */}

                            <div className="nav-item">
                                <Link className="nav-link dropdown-toggle" to='/' data-bs-toggle="collapse" data-bs-target="#navbarFollowUp" >
                                    <i className="bi-chat-left-dots nav-icon text-dark fw-bolder"></i>
                                    <span className="nav-link-title">{t("components.aside.follow-up")}</span>
                                </Link>
                                <div id="navbarFollowUp" className={`nav-collapse collapse ` + (location.pathname.startsWith('/follow-up') ? 'show' : '')} data-bs-parent="#navbarFollowUp" hs-parent-area="#navbarFollowUp" >
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/follow-up/tickets') ? 'active' : '')} to='/follow-up/tickets'>Tickets</Link>
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/follow-up/agents') ? 'active' : '')} to='/follow-up/agents'>{t("components.aside.reports.agents")}</Link>
                                </div>
                            </div>
                            {/* <div className="nav-item">
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/follow-up') ? 'active' : '')} to='/follow-up'>
                                        <i className="bi-chat-left-dots nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.tracking")}</span>
                                    </Link>
                                </div>*/}



                            <span className="dropdown-header fw-bold mt-5 text-white-dark">{t("components.aside.platform.platform-title")}</span>
                            <small className="bi-three-dots nav-subtitle-replacer"></small>



                            <div className="nav-item">
                                <Link className={`nav-link ` + (location.pathname.startsWith('/configuration') ? 'active' : '')} to='/configuration'>
                                    <i className="bi-gear nav-icon text-dark fw-bolder"></i>
                                    <span className="nav-link-title">{t("components.aside.platform.config")}</span>
                                </Link>
                            </div>
                            <div className="nav-item">
                                <Link className={`nav-link ` + (location.pathname.startsWith('/channels') ? 'active' : '')} to='/channels'>
                                    <i className="bi-collection nav-icon text-dark fw-bolder"></i>
                                    <span className="nav-link-title">{t("components.aside.platform.channels")}</span>
                                </Link>
                            </div>

                            <HasAccess onlyRoot>
                                <div className="nav-item">
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/accounts') ? 'active' : '')} to='/accounts'>
                                        <i className="bi-folder-plus nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.platform.accounts")}</span>
                                    </Link>
                                </div>
                            </HasAccess>
                            <HasAccess permission="user.show">
                                <div className="nav-item">
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/users') ? 'active' : '')} to='/users'>
                                        <i className="bi-people nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.platform.users")}</span>
                                    </Link>
                                </div>
                            </HasAccess>
                            {/* <HasAccess permission="payments.show">
                                <div className="nav-item ">
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/payments') ? 'active' : '')} to='/payments'>
                                        <i className="bi-credit-card-2-back nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.platform.payments")}</span>
                                    </Link>
                                </div>
                            </HasAccess> */}
                            {/* <HasAccess permission="bots.show">
                                <div className="nav-item">
                                    <Link className="nav-link " to={urlBotModule} state={{ account_id: account.account_id }}>
                                        <i className="bi-robot nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.platform.chatbot")}</span>
                                    </Link>
                                </div>
                            </HasAccess> */}
                            <HasAccess onlyRoot>
                                <div className="nav-item">
                                    <Link className={`nav-link ` + (location.pathname.startsWith('/support') ? 'active' : '')} to='/support'>
                                        <i className="bi bi-question-diamond nav-icon text-dark fw-bolder"></i>
                                        <span className="nav-link-title">{t("components.aside.platform.support")}</span>
                                    </Link>
                                </div>
                            </HasAccess>

                        </div>
                    </div>
                </div>
            </div>
        </aside>
    )
}

export default Aside